module.exports = __webpack_public_path__ + "nm-icons_27e18bd51168022b1ea49cb39e722a31.ttf?0f72f19bfc42e852260d67c9450380b5";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/fonts/iconfont/nm-icons_27e18bd51168022b1ea49cb39e722a31.ttf
// module id = 1396
// module chunks = 37